import { feesStats, studentDashboard, teachersStats } from "../../asset";
import { Counts } from "../../types/dashboardType";
// import { dashboardStats } from "../../util/Constants";

interface DashboardStatsProps {
  counts?: Counts;
}

export default function DashboardStats({ counts }: DashboardStatsProps) {
  const dashboardStats = [
    {
      title: "Students Present Today",
      icon: studentDashboard,
      value: counts?.totalStudentPresent,
      total: counts?.totalStudents,
      type: "attendance",
    },
    {
      title: "Teacher’s Present Today",
      icon: teachersStats,
      value: counts?.totalStaffPresent,
      total: counts?.totalStaff,
      type: "attendance",
    },
    {
      title: "Fee Collection Status",
      icon: feesStats,
      value: counts?.totalInvoicesPaid,
      total: counts?.totalInvoices,
      type: "fees",
      label: "Paid",
    },
  ];

  return (
    <div className="grid md:grid-cols-3 gap-3 text-neutral-400">
      {dashboardStats?.map((item, i) => (
        <div key={i} className="bg-white rounded-2xl shadow-[0_0_54px_0_rgba(0,0,0,0.05)] p-4">
          <div className="flex justify-between gap-8 items-start">
            <p className="text-sm font-normal capitalize">{item.title}</p>
            <img
              src={item.icon}
              alt={item.label}
              className="w-[60px] h-[60px]"
            />
          </div>
          <div className="flex gap-1 items-center">
            <p className="font-semibold text-[28px] tracking-[1px] text-neutral-500">
              {item.value ?? 0}
            </p>
            <p className="text-base font-semibold text-success-700">
              {item.label}
            </p>
            <p className="text-base">/ {item.total}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
